import {
  Box,
  Button,
  Divider,
  Flex,
  Grid,
  GridItem,
  HStack,
  Image,
  Link,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
  useBreakpointValue,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { BsCameraVideo, BsImage, BsLink } from "react-icons/bs";
import { FaFileAudio, FaFilePdf } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loading from "../../../components/common/Loading";
import TrDashboardHeader from "../../../components/common/TrainerDashboardHeader";
import Audio from "../../../components/trainee/resources/Audio";
import Documents from "../../../components/trainee/resources/Documents";
import Images from "../../../components/trainee/resources/Images";
import Links from "../../../components/trainee/resources/Links";
import Video from "../../../components/trainee/resources/Video";
import TrainerSidenav from "../../../components/trainer/courses/Sidenav";
import folder from "../../../img/folder.svg";
import rarrow from "../../../img/rarrow.svg";
import { IResources } from "../../../models/course/course-resource.model";
import trResourcesService from "../../../services/trainer/trResources.service";
import { getFullDate } from "../../../utils/classOfDegree";
import trainerRoutes from "../routes";

const TrResources = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isDocument, setDocument] = useState(false);
  const [isVideo, setVideo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [isAudio, setAudio] = useState(false);
  const [isLinks, setLinks] = useState(false);
  const [isImages, setImages] = useState(false);
  const [isResources, setResources] = useState(true);
  const [courseId, setCourseId] = useState("");
  const [videos, setVideoResources] = useState<IResources[]>();
  const [images, setImageResources] = useState<IResources[]>();
  const [links, setLinksResources] = useState<IResources[]>();
  const [audios, setAudioResources] = useState<IResources[]>();
  const [documents, setDocumentResources] = useState<IResources[]>();
  const [resources, setCourseResources] = useState<IResources[]>([]);
  const courseName: null | string = localStorage.getItem("courseName");
  const showSideNav = useBreakpointValue({ base: false, md: true, lg: true });

  const params = useParams();
  const course_id: any = params.course_id;

  const menuLinks = [
    {
      text: "Course Information",
      route: trainerRoutes.trainerCourses.CourseInformationLink(course_id),
      keywords: ["course-information"],
    },
    {
      text: "Announcements",
      route: trainerRoutes.trainerCourses.AnnouncementLink(course_id),
      keywords: ["announcement"],
    },
    {
      text: "My trainees",
      route: trainerRoutes.trainerCourses.TraineesLink(course_id),
      keywords: ["trainees", "my-attendance-list"],
    },
    {
      text: "Event Scheduler",
      route: trainerRoutes.trainerCourses.CalendarLink(course_id),
      keywords: ["calendar"],
    },
    {
      text: "Discussions",
      route: trainerRoutes.trainerCourses.DiscussionLink(course_id),
      keywords: ["discussion", "discussions"],
    },
    {
      text: "Assessments",
      route: trainerRoutes.trainerCourses.AssignmentsLink(course_id),
      keywords: ["assessments", "assignment"],
    },
    {
      text: "Results",
      route: trainerRoutes.trainerCourses.ResultLink(course_id),
      keywords: ["results", "result"],
    },
    {
      text: "Resources",
      route: trainerRoutes.trainerCourses.ResourcesLink(course_id),
      keywords: ["resource", "resources"],
    },
  ];

  const activeLink = (link: string, keywords: string[]) => {
    const style = {
      borderColor: "white",
      borderLeft: "",
      bgColor: "white",
      textColor: "#9E9E9E",
    };

    if (keywords.some((keyword) => location.pathname.includes(keyword))) {
      style.borderColor = "#EC3337";
      style.borderLeft = "3px Solid";
      style.bgColor = "#FFFAFA";
      style.textColor = " #EC3337";
    }

    return style;
  };

  useEffect(() => {
    const course_id: any = params.course_id;
    setDocument(false);
    setResources(true);
    setVideo(false);
    setAudio(false);
    setLinks(false);
    setImages(false);
    trResourcesService
      .getCourseResources(course_id)
      .then((response) => {
        const resources: IResources[] = response.data.course.resources;
        const videos = resources.filter((each) => each.file_type == "Video");
        const audios = resources.filter((each) => each.file_type == "Audio");
        const documents = resources.filter(
          (each) => each.file_type == "Document"
        );
        const images = resources.filter((each) => each.file_type == "Image");
        const links = resources.filter(
          (each) => each.file_type == "Text" || each.file_type == "Link"
        );

        setCourseResources(response.data.course.resources);
        setVideoResources(videos);
        setAudioResources(audios);
        setImageResources(images);
        setDocumentResources(documents);
        setLinksResources(links);
        setLoading(false);
      })
      .catch((err) => err);

    setCourseId(course_id);
  }, [reload]);

  const reloadData = () => {
    setReload(!reload);
  };

  const selectDocument = () => {
    setDocument(true);
    setResources(false);
    setVideo(false);
    setAudio(false);
    setLinks(false);
    setImages(false);
  };
  const selectVideo = () => {
    setDocument(false);
    setResources(false);
    setVideo(true);
    setAudio(false);
    setLinks(false);
    setImages(false);
  };
  const selectAudio = () => {
    setDocument(false);
    setResources(false);
    setVideo(false);
    setAudio(true);
    setLinks(false);
    setImages(false);
  };

  const selectImages = () => {
    setDocument(false);
    setResources(false);
    setVideo(false);
    setAudio(false);
    setLinks(false);
    setImages(true);
  };
  const selectLinks = () => {
    setDocument(false);
    setResources(false);
    setVideo(false);
    setAudio(false);
    setLinks(true);
    setImages(false);
  };
  const downloadFile = (url: string | undefined) => {
    // using Java Script method to get PDF file
    if (url) {
      fetch(url).then((response) => {
        response.blob().then((blob) => {
          // Creating new object of PDF file
          const fileURL = window.URL.createObjectURL(blob);
          // Setting various property values
          const alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = url;
          alink.click();
        });
      });
    }
  };
  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box width="100hw">
          <TrDashboardHeader />
          <Box
            bg="#F9F8F8"
            minHeight="100vh"
            height="auto"
            width="100%"
            pt={"1.5rem"}
          >
            {!showSideNav && (
              <HStack
                overflowX="scroll"
                width={"100vw"}
                height={"60px"}
                justifyContent={"space-around"}
                alignItems={"center"}
                fontSize={"13px"}
                padding={"0px 10px"}
                bg="white"
                className="scroll-hidden"
                mt="1.38rem"
                // flex={"no-wrap"}
              >
                {menuLinks.map((link, index) => (
                  <React.Fragment key={index}>
                    <Link
                      onClick={() => navigate(link.route)}
                      cursor={"pointer"}
                      textAlign={"center"}
                      alignContent={"center"}
                      wordBreak={"keep-all"}
                      height={"60px"}
                      width={"max-content"}
                      borderBottom={
                        activeLink(link.route, link.keywords).borderLeft
                      }
                      borderColor={
                        activeLink(link.route, link.keywords).borderColor
                      }
                      color={activeLink(link.route, link.keywords).textColor}
                    >
                      {link.text}
                    </Link>
                    {index < menuLinks.length - 1 && (
                      <Divider orientation="vertical" height="70%" />
                    )}
                  </React.Fragment>
                ))}
              </HStack>
            )}
            <Flex
              width="90%"
              mx="auto"
              pb="120px"
              pt={["50px", "60px", "60px", "80px"]}
              boxSizing="border-box"
            >
              {showSideNav && <TrainerSidenav />}
              <VStack
                minWidth={{ lg: "80%", md: "70%", sm: "95%", base: "95%" }}
                overflowX={"scroll"}
                className="scroll-hidden"
                mr="auto"
                boxSizing="border-box"
                // px="0px"
              >
                <HStack mr="auto" height={"2rem"} width={"100%"}>
                  <Text
                    as="span"
                    fontSize={["16px", "20px"]}
                    isTruncated
                    maxWidth={["180px", "200px", "350px", "500px"]}
                  >
                    {courseName && courseName.replaceAll(/"/g, "")}
                  </Text>
                  <Image src={rarrow} />
                  <Text as="span" fontSize={["16px", "20px"]} color={"#616161"}>
                    Resources
                  </Text>
                </HStack>
                {isResources && (
                  <Box
                    width="100%"
                    mx="auto"
                    // mb="1rem"
                    // padding={{
                    //   lg: "2.5rem",
                    //   md: "2rem",
                    //   sm: "1.4rem",
                    //   base: "1.4rem",
                    // }}
                    bg="white"
                    // bg="red"
                    pb={{
                      lg: "200px",
                      md: "150px",
                      sm: "110px",
                      base: "110px",
                    }}
                    px={{
                      lg: "2rem",
                      md: "2rem",
                      sm: "1.8rem",
                      base: "1rem",
                    }}
                    pt={{ lg: "3rem", md: "2.6rem", sm: "2rem", base: "2rem" }}
                  >
                    <Text
                      color="#1E1E1E"
                      fontSize={{
                        lg: "28px",
                        md: "20px",
                        sm: "18px",
                        base: "18px",
                      }}
                      pb={["20px", "30px"]}
                      fontWeight="600"
                    >
                      Resources{" "}
                    </Text>
                    {/* <Flex flexWrap="wrap">
                      <Flex
                        width="30%"
                        mr="2%"
                        mb="15px"
                        cursor="pointer"
                        onClick={() => selectDocument()}
                        pb="14px"
                        pt="10px"
                        pl={["18px", "28px", "28px", "38px"]}
                        borderRadius="5px"
                        border="0.5px solid"
                        borderColor="#9E9E9E"
                      >
                        <Image
                          height={["20px", "30px", "40px", "50px"]}
                          width={["20px", "30px", "40px", "50px"]}
                          src={folder}
                        />
                        <Text
                          pt={["10px", "15px", "15px", "20px"]}
                          fontWeight="600"
                          fontSize={["14px", "15px", "16px", "18px"]}
                          pb="10px"
                          color="#616161"
                        >
                          Documents
                        </Text>
                      </Flex>
                      <Flex
                        width="30%"
                        mr="2%"
                        mb="15px"
                        cursor="pointer"
                        onClick={() => selectVideo()}
                        pb="14px"
                        pl={["18px", "28px", "28px", "38px"]}
                        pt="10px"
                        borderRadius="5px"
                        border="0.5px solid"
                        borderColor="#9E9E9E"
                      >
                        <Image
                          height={["30px", "30px", "40px", "50px"]}
                          width={["30px", "30px", "40px", "50px"]}
                          src={folder}
                        />
                        <Text
                          pt={["10px", "15px", "15px", "20px"]}
                          fontWeight="600"
                          fontSize={["14px", "15px", "16px", "18px"]}
                          pb="10px"
                          color="#616161"
                        >
                          Video
                        </Text>
                      </Flex>
                      <Flex
                        width="30%"
                        mr="2%"
                        mb="15px"
                        cursor="pointer"
                        onClick={() => selectAudio()}
                        pb="14px"
                        pl={["18px", "28px", "28px", "38px"]}
                        pt="10px"
                        borderRadius="5px"
                        border="0.5px solid"
                        borderColor="#9E9E9E"
                      >
                        <Image
                          height={["30px", "30px", "40px", "50px"]}
                          width={["30px", "30px", "40px", "50px"]}
                          src={folder}
                        />
                        <Text
                          pt={["10px", "15px", "15px", "20px"]}
                          fontWeight="600"
                          fontSize={["14px", "15px", "16px", "18px"]}
                          pb="10px"
                          color="#616161"
                        >
                          Audio
                        </Text>
                      </Flex>
                      <Flex
                        width="30%"
                        mr="2%"
                        mb="15px"
                        cursor="pointer"
                        onClick={() => selectImages()}
                        pb="14px"
                        pl={["18px", "28px", "28px", "38px"]}
                        pt="10px"
                        borderRadius="5px"
                        border="0.5px solid"
                        borderColor="#9E9E9E"
                      >
                        <Image
                          height={["30px", "30px", "40px", "50px"]}
                          width={["30px", "30px", "40px", "50px"]}
                          src={folder}
                        />
                        <Text
                          pt={["10px", "15px", "15px", "20px"]}
                          fontWeight="600"
                          fontSize={["14px", "15px", "16px", "18px"]}
                          pb="10px"
                          color="#616161"
                        >
                          Image
                        </Text>
                      </Flex>
                      <Flex
                        width="30%"
                        mr="2%"
                        mb="15px"
                        cursor="pointer"
                        onClick={() => selectLinks()}
                        pb="14px"
                        pl={["18px", "28px", "28px", "38px"]}
                        pt="10px"
                        borderRadius="5px"
                        border="0.5px solid"
                        borderColor="#9E9E9E"
                      >
                        <Image
                          height={["30px", "30px", "40px", "50px"]}
                          width={["30px", "30px", "40px", "50px"]}
                          src={folder}
                        />
                        <Text
                          pt={["10px", "15px", "15px", "20px"]}
                          fontWeight="600"
                          fontSize={["14px", "15px", "16px", "18px"]}
                          pb="10px"
                          color="#616161"
                        >
                          Links
                        </Text>
                      </Flex>
                    </Flex> */}
                    <Grid
                      templateColumns={{
                        base: "repeat(2, auto)",
                        md: "repeat(2, auto)",
                        lg: "repeat(3, auto)",
                      }}
                      gap={["4px", "1rem"]}
                    >
                      <GridItem>
                        <Flex
                          cursor="pointer"
                          onClick={() => selectDocument()}
                          pb="14px"
                          pt="10px"
                          pl={["8px", "28px", "28px", "38px"]}
                          borderRadius="5px"
                          border="0.5px solid"
                          borderColor="#9E9E9E"
                        >
                          <Image
                            height={["30px", "30px", "40px", "50px"]}
                            width={["30px", "30px", "40px", "50px"]}
                            src={folder}
                          />
                          <Text
                            pt={["10px", "15px", "15px", "20px"]}
                            fontWeight="600"
                            fontSize={["14px", "15px", "16px", "18px"]}
                            pb="10px"
                            color="#616161"
                            isTruncated
                          >
                            Documents
                          </Text>
                        </Flex>
                      </GridItem>
                      <GridItem>
                        <Flex
                          cursor="pointer"
                          onClick={() => selectVideo()}
                          pb="14px"
                          pl={["8px", "28px", "28px", "38px"]}
                          pt="10px"
                          borderRadius="5px"
                          border="0.5px solid"
                          borderColor="#9E9E9E"
                        >
                          <Image
                            height={["30px", "30px", "40px", "50px"]}
                            width={["30px", "30px", "40px", "50px"]}
                            src={folder}
                          />
                          <Text
                            pt={["10px", "15px", "15px", "20px"]}
                            fontWeight="600"
                            fontSize={["14px", "15px", "16px", "18px"]}
                            pb="10px"
                            color="#616161"
                          >
                            Video
                          </Text>
                        </Flex>
                      </GridItem>
                      <GridItem>
                        <Flex
                          cursor="pointer"
                          onClick={() => selectAudio()}
                          pb="14px"
                          pl={["18px", "28px", "28px", "38px"]}
                          pt="10px"
                          borderRadius="5px"
                          border="0.5px solid"
                          borderColor="#9E9E9E"
                        >
                          <Image
                            height={["30px", "30px", "40px", "50px"]}
                            width={["30px", "30px", "40px", "50px"]}
                            src={folder}
                          />
                          <Text
                            pt={["10px", "15px", "15px", "20px"]}
                            fontWeight="600"
                            fontSize={["14px", "15px", "16px", "18px"]}
                            pb="10px"
                            color="#616161"
                          >
                            Audio
                          </Text>
                        </Flex>
                      </GridItem>
                      <GridItem>
                        <Flex
                          cursor="pointer"
                          onClick={() => selectImages()}
                          pb="14px"
                          pl={["18px", "28px", "28px", "38px"]}
                          pt="10px"
                          borderRadius="5px"
                          border="0.5px solid"
                          borderColor="#9E9E9E"
                        >
                          <Image
                            height={["30px", "30px", "40px", "50px"]}
                            width={["30px", "30px", "40px", "50px"]}
                            src={folder}
                          />
                          <Text
                            pt={["10px", "15px", "15px", "20px"]}
                            fontWeight="600"
                            fontSize={["14px", "15px", "16px", "18px"]}
                            pb="10px"
                            color="#616161"
                          >
                            Image
                          </Text>
                        </Flex>
                      </GridItem>
                      <GridItem>
                        <Flex
                          cursor="pointer"
                          onClick={() => selectLinks()}
                          pb="14px"
                          pl={["18px", "28px", "28px", "38px"]}
                          pt="10px"
                          borderRadius="5px"
                          border="0.5px solid"
                          borderColor="#9E9E9E"
                        >
                          <Image
                            height={["30px", "30px", "40px", "50px"]}
                            width={["30px", "30px", "40px", "50px"]}
                            src={folder}
                          />
                          <Text
                            pt={["10px", "15px", "15px", "20px"]}
                            fontWeight="600"
                            fontSize={["14px", "15px", "16px", "18px"]}
                            pb="10px"
                            color="#616161"
                          >
                            Links
                          </Text>
                        </Flex>
                      </GridItem>
                    </Grid>
                    <Flex
                      justifyContent="space-between"
                      alignItems="center"
                      py="15px"
                      width={"100%"}
                    >
                      <Box
                        color="#2B2B2B"
                        fontWeight="800"
                        fontSize={["16px", "20px", "24px"]}
                      >
                        Recent Uploads
                      </Box>
                      <Button
                        onClick={() => {
                          navigate(
                            trainerRoutes.trainerCourses.UploadResourcesLink(
                              courseId
                            )
                          );
                        }}
                        fontSize={12}
                        borderRadius={2}
                        p="7px"
                        colorScheme="red"
                        size="sm"
                        textTransform={"uppercase"}
                      >
                        Upload new file
                      </Button>
                    </Flex>

                    <TableContainer
                      mt={5}
                      mb="100px"
                      overflowX={"scroll"}
                      className="scroll-hidden"
                      width={"100%"}
                      position={"relative"}
                    >
                      <Table variant="simple" maxWidth={"100%"}>
                        <Thead fontWeight="normal" fontSize="15px">
                          <Tr color="#828282">
                            <Th textTransform="none">File</Th>
                            <Th textTransform="none">File Type</Th>
                            <Th textTransform="none">Uploaded On</Th>
                            <Th textTransform="none">Action</Th>
                          </Tr>
                        </Thead>

                        <Tbody>
                          {resources && resources.length > 0 ? (
                            resources.slice(0, 5).map((each, index) => (
                              <Tr
                                key={index}
                                fontSize="14px"
                                color="#828282"
                                width={"100%"}
                              >
                                <Td>
                                  <HStack maxWidth="400px" isTruncated>
                                    {each.file_type == "Text" ||
                                    each.file_type == "Link" ? (
                                      <BsLink fontSize={"30px"} />
                                    ) : each.file_type == "Audio" ? (
                                      <FaFileAudio fontSize={"30px"} />
                                    ) : each.file_type == "Document" ? (
                                      <FaFilePdf fontSize={"30px"} />
                                    ) : each.file_type == "Video" ? (
                                      <BsCameraVideo fontSize={"30px"} />
                                    ) : each.file_type == "Image" ? (
                                      <BsImage fontSize={"30px"} />
                                    ) : (
                                      <BsImage />
                                    )}
                                    {each.file_type === "Link" ? (
                                      <Text isTruncated maxWidth="300px">
                                        {each.file_url?.substring(0, 70)}
                                      </Text>
                                    ) : (
                                      <Text isTruncated maxWidth="300px">
                                        {each.file_name.substring(0, 70)}
                                      </Text>
                                    )}
                                  </HStack>
                                </Td>
                                <Td>
                                  <Text isTruncated>
                                    {each.file_type ? each.file_type : "nil"}
                                  </Text>
                                </Td>
                                <Td>
                                  <HStack spacing={2}>
                                    <Text>{getFullDate(each.created_at)}</Text>
                                  </HStack>
                                </Td>
                                <Td>
                                  {each.file_type == "Text" ? (
                                    <a
                                      target="_blank"
                                      rel="noreferrer"
                                      href={`https://${each.file_url}`}
                                    >
                                      go to
                                    </a>
                                  ) : (
                                    <Button
                                      py="13px"
                                      px="30px"
                                      onClick={() => {
                                        downloadFile(each.file_url);
                                      }}
                                      fontSize={11}
                                      borderRadius={0}
                                      colorScheme="gray"
                                      size="sm"
                                    >
                                      DOWNLOAD
                                    </Button>
                                  )}
                                </Td>
                              </Tr>
                            ))
                          ) : (
                            <Box textAlign={"center"}>
                              No resources yet, upload resource
                            </Box>
                          )}
                        </Tbody>
                      </Table>
                    </TableContainer>
                  </Box>
                )}
                {isDocument && (
                  <Documents files={documents} reload={reloadData} />
                )}
                {isVideo && <Video files={videos} reload={reloadData} />}
                {isAudio && <Audio files={audios} reload={reloadData} />}
                {isImages && <Images files={images} reload={reloadData} />}
                {isLinks && <Links files={links} reload={reloadData} />}
              </VStack>
            </Flex>
          </Box>
        </Box>
      )}
    </>
  );
};

export default TrResources;
